const getters = {
    getCodeModule: state => state.data.code,
    getCodeApiModule: state => state.data.codeAPI,
    getModule: state => state.data.module,
    getModuleName: state => state.data.module ? state.data.module.name || '' : '',
    getModules: state => state.data.module && state.data.module.portal ? state.data.module.portal : [],
    getTools: state => state.data.tools ? state.data.tools : {},
    getAcl: (state, getters) => (id) => {
        let panels = state.data.panels;
        let tools = getters.getTools;
        return tools[id] ? tools[id].acl : (panels[id] ? panels[id].acl : {});
    },
    getUrl: (state, getters) => (id) => {
        let panels = state.data.panels;
        let tools = getters.getTools;
        return tools[id] ? tools[id].url : (panels[id] ? panels[id].url : {});
    },
};

export default getters;